<template>
	<div class="simple-check">
		<div class="progress-check ts-text-center" v-if="!resources.length">
			<h2 class="ts-mb-3 ts-font-mono">{{ step }}</h2>
			<div class="check-message">
				<span class="dot" v-for="n in 5" :key="n" :style="dotStyle(n)"></span>
			</div>
		</div>

		<div class="result ts-font-mono" :class="result" v-if="resources.length">
			{{ '✗ Missing score entry on classes' }}
		</div>

		<div class="ts-mt-3 ts-space-y-2 ts-text-center ts-font-mono" v-if="resources.length">
			<div v-for="(items, subject) in classList" class="fadeIn">
				<p class="ts-text-center ts-mt-3 ts-bg-gray-100 ts-text-gray-500 ts-px-2 ts-rounded-md">{{ subject }}
				</p>
				<div class="ts-px-3">
					<div v-for="cl in items">
						<p>{{ cl.class_name + '|' + cl.class_desc + '|' + cl.cycle_value_text }}</p>
					</div>
				</div>
			</div>
		</div>

		<div class="ts-flex ts-justify-end ts-space-x-2 ts-mt-8" v-if="resources.length">
			<ts-button @click="ignoreAndRelease" color="primary" outline class="ts-w-32">{{ $t('totalScoreGenerate.ignoreAndRelease')
			}}</ts-button>
			<ts-button @click="$emit('cancel')" color="danger" class="ts-w-32">{{ $t('totalScoreGenerate.abort')
			}}</ts-button>
		</div>

	</div>
</template>

<script>
import { groupBy } from 'lodash';

export default {
	props: {
		step: {
			type: String,
			default: () => 'Verifying'
		},
		resources: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			result: 'error',
			checking: false,
			message: ''

		}
	},
	computed: {
		classList() {
			return groupBy(this.resources, 'subject');
		}
	},
	methods: {
		dotStyle(n) {
			return {
				animationDelay: `${n * 0.3}s`
			};
		},
		ignoreAndRelease() {
			this.$emit('release')
		}
	}
}
</script>

<style scoped>
.check-message {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 4px;
	color: #666;
}

.dot {
	width: 6px;
	height: 6px;
	background: #3c97d3;
	border-radius: 50%;
	animation: dotPulse 1.5s infinite;
}

@keyframes dotPulse {

	0%,
	100% {
		opacity: 0.3;
		transform: scale(0.8);
	}

	50% {
		opacity: 1;
		transform: scale(1.2);
	}
}

.result {
	padding: 10px;
	border-radius: 4px;
	margin-top: 10px;
	text-align: center;
	font-weight: bold;
	animation: fadeIn 0.5s ease;
}

.result.success {
	background: #e8f5e8;
	color: #2e7d32;
}

.result.error {
	background: #ffebee;
	color: #c62828;
}

.fadeIn {
	animation: fadeIn 0.8s ease;
}

@keyframes fadeIn {
	from {
		opacity: 0;
		transform: translateY(-10px);
	}

	to {
		opacity: 1;
		transform: translateY(0);
	}
}
</style>